import { type PayableId } from 'modules/payable/models';
import { useMutation } from 'src/core/api/hooks/useMutation';

import { useInvalidateBookkeepingNavbarCounters } from '../useInvalidateBookkeepNavbarCounters';

type MarkPayablesAsManuallyAccountedError = {
  outcome: 'notMarkedAsManuallyAccounted';
} & (
  | {
      reason: 'expectationFailure';
      error: Error;
    }
  | {
      reason: 'invalidBodyParams';
      error: Error;
    }
  | {
      reason:
        | 'unauthorized'
        | 'notFound'
        | 'invalidState'
        | 'wrongVersion'
        | 'updateInProgress'
        | 'nothingToUpdate';
    }
);

type MarkPayablesAsManuallyAccountedResponse = {
  outcome: 'markedAsManuallyAccounted';
};

type MarkPayablesAsManuallyAccountedPayload = {
  payableId: PayableId;
  payableVersion: number;
}[];

/**
 * Mutation
 **/

export const useMarkPayablesAsManuallyAccounted = () => {
  const invalidateBookkeepingNavbarCounters =
    useInvalidateBookkeepingNavbarCounters();

  return useMutation<
    MarkPayablesAsManuallyAccountedPayload,
    MarkPayablesAsManuallyAccountedResponse,
    MarkPayablesAsManuallyAccountedResponse,
    MarkPayablesAsManuallyAccountedError
  >({
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: `/bookkeeping/payable/mark-as-manually-accounted-all`,
      method: 'post',
    },
    options: {
      throwOnError: true,
      onSuccess: ({ data }) => {
        if (data.outcome === 'markedAsManuallyAccounted') {
          invalidateBookkeepingNavbarCounters();
        }
      },
    },
    reshapeData(data) {
      return data;
    },
  });
};
